import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function DeleteCircleIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <g id="Group 5625">
      <path id="Vector 1179" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
            d="m9.53174 4.46875 -5.0625 5.0625" strokeWidth="1"></path>
      <path id="Vector 1180" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
            d="m9.53174 9.53125 -5.0625 -5.0625" strokeWidth="1"></path>
    </g>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M7 13.5c4.16 0 6.5 -2.34 6.5 -6.5S11.16 0.5 7 0.5 0.5 2.84 0.5 7s2.34 6.5 6.5 6.5Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
